<cms-modal-layout>
    <span title class="title">What's new in CMS!</span>
    <div content [innerHTML]="releaseInfo" ></div>
    <span closeBtnTitle>Close</span>


</cms-modal-layout>
